<template>
    <div class="app-container">
        <DT_NavBar
            :tool="tool"
            :showMenu="false"
            :menuCollapsed="menuCollapsed"
            @loadProject="handleNavLoad"
            @reset="handleReset"
            @toggleCollapse="toggleCollapse"
        />

        <div class="main-content hub-content">
            <!-- Top Navbar -->
            <nav class="mmp-fixed-nav">
                <div class="mmp-user-info">
                    <span class="mmp-user-avatar">
                        <fa :icon="['fas', 'user']" />
                    </span>
                    <span class="mmp-user-greeting">
                        <span class="mmp-user-greeting-label">Welcome back</span>
                        <span class="mmp-user-greeting-name">{{ user ? user : '' }}</span>
                    </span>
                </div>
                <div class="mmp-nav-actions">
                    <button
                        class="notif-bell-btn signout-btn"
                        title="Sign Out"
                        @click="signOut"
                    >
                        <fa :icon="['fas', 'sign-out-alt']" />
                    </button>
                </div>
            </nav>

            <!-- Widget Cards -->
            <div class="hub-center">
                <p class="hub-subtitle">Select a tool to get started</p>
                <div class="hub-widgets">
                    <div class="hub-card" @click="goTo('DDT')" v-if="globalIsUserAllowed('Data_Delivery_Tool')">
                        <div class="hub-icon-wrap">
                            <fa :icon="['fas', 'road']" class="hub-icon" />
                        </div>
                        <div class="hub-card-body">
                            <div class="hub-title">Map Data</div>
                            <div class="hub-desc">Request, track, and manage data delivery orders across regions.</div>
                        </div>
                        <div class="hub-arrow">
                            <!-- <fa :icon="['fas', 'arrow-right']" /> -->
                        </div>
                    </div>

                    <div class="hub-card" @click="goTo('TRT')" v-if="globalIsUserAllowed('Trail_Review_Tool')">
                        <div class="hub-icon-wrap">
                            <fa :icon="['fas', 'route']" class="hub-icon" />
                        </div>
                        <div class="hub-card-body">
                            <div class="hub-title">Lidar Data</div>
                            <div class="hub-desc">Review, submit, and manage trail sample requests.</div>
                        </div>
                        <div class="hub-arrow">
                            <!-- <fa :icon="['fas', 'arrow-right']" /> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="copyright">
                <a href="https://dmp-maps.com/legal/" class="attribution" target="_blank">
                    © {{ new Date().getFullYear() }} Dynamic Map Platform North America, Inc. All Rights Reserved
                </a>
            </div>
        </div>
    </div>
</template>

<style src="./Data_Tools.css" scoped></style>
<style scoped>
.hub-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f8f9fa;
    overflow: hidden;
}

.mmp-fixed-nav {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.65rem 1.5rem;
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    border-bottom: 1px solid rgba(6, 60, 109, 0.08);
    box-shadow: 0 1px 12px rgba(6, 60, 109, 0.06);
}

.mmp-user-info {
    display: flex;
    align-items: center;
    flex-direction: row;
    color: #063c6d;
    gap: 0.75rem;
}

.mmp-user-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: linear-gradient(135deg, #0a548f 0%, #063c6d 100%);
    box-shadow: 0 2px 8px rgba(6, 60, 109, 0.25);
    overflow: hidden;
    flex: 0 0 auto;
}

.mmp-user-avatar svg {
    width: 1.125rem;
    height: 1.125rem;
    color: #ffffff;
}

.mmp-user-greeting {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.mmp-user-greeting-label {
    font-size: 0.72rem;
    font-weight: 500;
    color: #8ab0cc;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.mmp-user-greeting-name {
    font-size: 1.02rem;
    font-weight: 700;
    color: #063c6d;
}

.mmp-nav-actions {
    display: flex;
    align-items: center;
    gap: 0.625rem;
}

.notif-bell-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.625rem;
    height: 2.625rem;
    border: 1px solid rgba(6, 60, 109, 0.1);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.6);
    color: #4A74A8;
    font-size: 1.05rem;
    cursor: pointer;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
    flex: 0 0 auto;
}

.notif-bell-btn:hover {
    background: #ffffff;
    color: #063c6d;
    box-shadow: 0 4px 14px rgba(6, 60, 109, 0.14);
    transform: translateY(-1px);
}

.signout-btn:hover {
    background: #fff;
    color: #dc3545;
    box-shadow: 0 4px 14px rgba(220, 53, 69, 0.18);
}

.hub-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    gap: 1.5rem;
}

.hub-subtitle {
    color: #6c757d;
    font-size: 1rem;
    margin: 0;
    letter-spacing: 0.3px;
}

.hub-widgets {
    display: flex;
    flex-direction: row;
    gap: 2.5rem;
    flex-wrap: wrap;
    justify-content: center;
}

.hub-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
    background: #fff;
    border: 1px solid #dee2e6;
    border-left: 6px solid #4A74A8;
    border-radius: 14px;
    padding: 2.5rem 3rem;
    width: 32.5rem;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(74, 116, 168, 0.12);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-left-color 0.18s ease;
}

.hub-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(74, 116, 168, 0.22);
    border-left-color: #316fb1;
}

.hub-card:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(74, 116, 168, 0.18);
}

.hub-icon-wrap {
    width: 5.625rem;
    height: 5.625rem;
    background-color: #eef3f9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background-color 0.18s ease;
}

.hub-card:hover .hub-icon-wrap {
    background-color: #4A74A8;
}

.hub-icon {
    font-size: 2rem;
    color: #4A74A8;
    transition: color 0.18s ease;
}

.hub-card:hover .hub-icon {
    color: #fff;
}

.hub-card-body {
    flex: 1;
}

.hub-title {
    font-size: 1.35rem;
    font-weight: 600;
    color: #063c6d;
    margin-bottom: 0.5rem;
}

.hub-desc {
    font-size: 0.95rem;
    color: #6c757d;
    line-height: 1.5;
}

.hub-arrow {
    color: #4A74A8;
    font-size: 1rem;
    opacity: 0;
    transform: translateX(-6px);
    transition: opacity 0.18s ease, transform 0.18s ease;
}

.hub-card:hover .hub-arrow {
    opacity: 1;
    transform: translateX(0);
}

.user-dropdown {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    box-shadow: 0 6px 20px rgba(74, 116, 168, 0.18);
    min-width: 10rem;
    z-index: 1000;
    overflow: hidden;
}

.user-dropdown-item {
    display: flex;
    align-items: center;
    padding: 0.7rem 1.1rem;
    font-size: 0.92rem;
    color: #063c6d;
    cursor: pointer;
    transition: background 0.15s ease;
}

.user-dropdown-item:hover {
    background: #eef3f9;
    color: #4A74A8;
}

.copyright {
    position: fixed;
    bottom: 0;
    right: 0;
}

.attribution {
display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.3125rem 0.875rem;
    color: #063c6d !important;
    font-size: 0.8125rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.55);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    border: none;
    border-radius: 999px;
    -webkit-transition: color 0.15s ease, background 0.15s ease;
    transition: color 0.15s ease, background 0.15s ease;
}

.attribution:hover {
    color: #0056b3 !important;
    text-decoration: underline !important;
}
</style>

<script>
import DT_NavBar from './DT_NavBar.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'DT_LandingPage',
    components: { DT_NavBar },
    computed: {
        ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed'])
    },
    data() {
        return {
            user: null,
            showUserMenu: false,
            tool:null,
            org:null,
            menuCollapsed: false
        }
    },
    methods: {
        toggleCollapse() {
            this.menuCollapsed = !this.menuCollapsed
        },
        goTo(tool) {
            if (tool === 'DDT') {
                this.tool='DDT'
                this.$router.push({ name: 'DDT', query: { openMap: '1' } });
            } else if (tool === 'TRT') {
                  this.tool='TRT'
                this.$router.push({ name: 'TRT', query: { openMap: '1' } });
            }
        },
        handleNavLoad(project) {
            if (project === 'Maps') {
                this.$router.push({ name: 'DDT' });
            }
        },
        handleReset(resolve) {
            if (resolve) resolve();
        },
        signOut() {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('pid');
            this.$router.push({ name: 'Login' });
        }
    },
    mounted() {
        this.user= sessionStorage.getItem('username')
        this.org= sessionStorage.getItem('organization')

    }
}
</script>
